"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var preact_1 = require("preact");

var hooks_1 = require("preact/hooks");

var config_1 = require("../constants/config"); // 알림 항목 아이콘 출력


function ProfileImage(_ref) {
  var id = _ref.id;
  var url = (0, hooks_1.useMemo)(function () {
    if (id) {
      var szFolder = id.substring(0, 2);
      return "".concat(config_1.BJ_PROFILE_DOMAIN, "/LOGO/").concat(szFolder, "/").concat(id, "/").concat(id, ".jpg");
    } else {
      return "".concat(config_1.RES_DOMAIN, "/images/afmain/img_thumb_profile.gif");
    }
  }, [id]);
  return (0, preact_1.h)("img", {
    src: url,
    alt: "\uD504\uB85C\uD544 \uC774\uBBF8\uC9C0"
  });
}

exports.default = ProfileImage;